// extracted by mini-css-extract-plugin
export default {"EditClientDialog":"EditClientDialog_EditClientDialog__XMMSh"};